import React, { useEffect, useRef, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import { Link } from "react-router-dom";
import Pagination from "../components/Pagination";
import { getBrands } from "../helpers/Brands";


export default function Brands() {
    const { appState } = useAppState();
    const [brands, setBrands] = useState<Array<any>>([])
    const [search, setSearch] = useState<string | null>(null)
    const [page, setPage] = useState<number>(1)
    const [meta, setMeta] = useState<any>({
        page: 1,
        totalPages: 1,
    });
    const abortController = useRef<AbortController>();


    useEffect(() => {
        if (abortController.current) {
            abortController.current.abort()
        }
        abortController.current = new AbortController();
        getBrands(10, page, search, { signal: abortController.current.signal }).then((result) => {
            setBrands(result.data)
            setMeta({
                page: result.current_page,
                totalPages: result.last_page,
            })
        })
    }, [page, search])

    useEffect(() => {
        setPage(1);
    }, [search])

    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-xl">Brands</h1>
                    <input onChange={(event) => { setSearch(event.target.value) }}></input>
                </div>
                <Link to="/brands/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create Brand</Link>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <table className="w-full">
                    <thead className="text-left">
                        <tr className="border-b-1">
                            <th className="p-2">Id</th>
                            <th className="p-2">Name</th>
                            <th className="p-2 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {brands.map((brand: any) => {
                            return (
                                <tr className="border-b-1 border-gray-300">
                                    <td className="p-2">
                                        <Link to={`/brands/${brand.id}`}>{brand.id}</Link>
                                    </td>
                                    <td className="p-2">{brand.name}</td>
                                    <td className="p-2 ">
                                        <ul className="flex justify-end gap-x-2">
                                            <li>
                                                {/* <Link to={`/invoices/${invoice.id}`}>View</Link> */}
                                            </li>
                                            <li>
                                                {/* <a target="_blank" href={invoice.payment_link}>Link</a> */}
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {brands && brands.length > 0 ? (
                <div className="w-full mt-5">
                    <Pagination page={meta.page} totalPages={meta.totalPages} onCallback={setPage} />
                </div>
            ) : null}

        </>
    );
}
